import React, { useEffect, useState, useRef } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageStyle from "../../../Components/Layout/PageLayout";
import Table from "../../../Components/Table/Table";
// import Select from "react-select"; // unused
import {
  FilterButton,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
// import Pagination from "../../../Components/Pagination/Pagination";
// import { useNavigate } from "react-router"; // unused
import { useDispatch, useSelector } from "react-redux";
import { TableActions } from "../../../Components/Misc/Actions";
import { format } from "date-fns";
import {
  GetApplicant,
  // AcceptOffer, // unused
  // RejectOffer, // unused
  // CloseOffer, // unused
  // ScheduleTnterviewWithCandidate, // unused
  // RescheduleTnterviewWithCandidate, // unused
  MoveCandidateToSelected,
  GetEmployeeCadrePosition,
} from "../../../../../utils/redux/HR/HRSlice";
// import { CTAButtons } from "../../../../global/components/Buttons/buttons";
import {
  // AiFillCaretLeft,
  // AiFillCaretRight,
  AiOutlineExclamationCircle,
} from "react-icons/ai";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { toast } from "react-toastify";
import // FormInput,
// FormsSelect,
// FormTemplate, // unused
"../../../Components/Forms/InputTemplate";
// import { FormProvider, useForm } from "react-hook-form"; // unused
import { AttachToCarde } from "./AttachToCarde";
import { useNavigate } from "react-router";

function ApplicantSelected({ data, type }) {
  const [status, _setStatus] = useState(null);
  const [modalAction, setModalAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showScheduleInterviewModal, setShowScheduleInterviewModal] =
    useState(false);
  const modalRef = useRef(null);
  const [selectedPayrollId, setSelectedPayrollId] = useState(null);
  const [filter, setFilter] = useState(5);
  const [search, _setSearch] = useState("");
  const [pageSize, _setPageSize] = useState(10);
  const [pageNumber, _setPageNumber] = useState(1);
  const [action, _setAction] = useState();

  const _navigate = useNavigate(); // unused
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);

  const getRequest = useSelector((state) => state?.hr);
  const { get_applicant, isLoading, cadre_position } = getRequest;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  let start =
    startDate === undefined ? "" : format(new Date(startDate), "DD/MM/YYYY");
  let end =
    endDate === undefined ? "" : format(new Date(endDate), "DD/MM/YYYY");

  const apiData = {
    pageSize: pageSize,
    pageNumber: pageNumber,
    startDate: start,
    endDate: end,
    // action: action,
    search: search,
    JobListingId: data,
    InterviewStatus: filter,
  };
  useEffect(() => {
    dispatch(GetApplicant(apiData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    status,
    pageNumber,
    pageSize,
    search,
    startDate,
    endDate,
    action,
    refresh,
  ]);

  let applicant = get_applicant?.result;
  const [searchTerm, setSearchTerm] = useState("");

  const filterBy = [
    {
      name: "Approved",
      filter: 0,
    },
    // {
    //   name: "Pending",
    //   filter: 1,
    // },
    // {
    //   name: "Declined",
    //   filter: 7,
    // },
    // {
    //   name: "Cancelled",
    //   filter: 11,
    // },
    {
      name: "Closed",
      filter: 2,
    },
    {
      name: "Selected",
      filter: 5,
    },
    // {
    //   name: "Accepted",
    //   filter: 4,
    // },
    {
      name: "ApprovedByEDO",
      filter: 30,
    },
    // {
    //   name: "ApprovedByEDFI",
    //   filter: 60,
    // },
    {
      name: "ApprovedByMD",
      filter: 10,
    },
  ];

  const handleOpenModal = (action, payrollId) => {
    setModalAction(action);
    setSelectedPayrollId(payrollId); // Assuming you're using a state to hold the currently selected ID
    if (action === "Interview" || action === "Reschedule") {
      setShowScheduleInterviewModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleCloseModal = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setShowModal(false);
    }
  };

  const handleMoveToSelected = async () => {
    const payload = {
      applicantId: selectedPayrollId,
    };

    try {
      const actionDispatchFunction = await dispatch(
        MoveCandidateToSelected(payload)
      );
      if (actionDispatchFunction?.payload?.successful === true) {
        // Do something upon successful action
        setRefresh(!refresh);
        setShowModal(false);
        toast.success(actionDispatchFunction?.payload?.statusMessage);
      } else if (actionDispatchFunction?.payload?.successful === false) {
        toast.error(actionDispatchFunction?.payload?.statusMessage);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    dispatch(
      GetEmployeeCadrePosition({
        pageSize: 1000000,
        pageNumber: 1,
        approvalStatus: 0,
      })
    );
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseModal);
    return () => {
      document.removeEventListener("mousedown", handleCloseModal);
    };
  }, []);

  return (
    <PageStyle
      title={"Attach Cadre and Level"}
      hasBack={false}
      // action={actionButton}
      isMain={true}
    >
      <div className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          text={(value) => setSearchTerm(value)}
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />

        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={filterBy}
        />

        <FilterButton onClick={() => setRefresh(!refresh)} name="" />
      </div>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Date of Birth</th>
              <th>Email</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Other Name</th>
              <th>Location</th>
              <th>Phone</th>
              <th>interview Status</th>
              <th>Offer Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {applicant?.map((acq, index) => (
              <AcqTable
                {...acq}
                index={index}
                isLoading={isLoading}
                key={index}
                handleOpenModal={handleOpenModal}
                data={acq}
                type={type}
              />
            ))}
          </tbody>
        </Table>
      </div>
      {/* <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.pageSize}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setPageNumber(page)}
      /> */}

      {showModal &&
        modalAction !== "Interview" &&
        modalAction !== "Reschedule" && (
          <div className={DashboardStyle.modalOverlay}>
            <div className={DashboardStyle.modal1} ref={modalRef}>
              <div className={DashboardStyle.modalcontent1}>
                <div className={DashboardStyle.cycler}>
                  <AiOutlineExclamationCircle
                    size={24}
                    style={{ color: "brown" }}
                  />
                </div>
                <h1 style={{ textAlign: "center", fontSize: "20px" }}>
                  {modalAction === "Selected"
                    ? "Are you sure you want to move this applicant to the selected list ?"
                    : ""}
                </h1>
              </div>

              <div className={DashboardStyle.modalfooter1}>
                <button
                  className={DashboardStyle.greenButton}
                  onClick={handleMoveToSelected}
                >{`Yes, ${modalAction}`}</button>
                <button
                  onClick={() => setShowModal(false)}
                  className={DashboardStyle.whiteButton2}
                >
                  No, Close
                </button>
              </div>
            </div>
          </div>
        )}

      {showScheduleInterviewModal && (
        <AttachToCarde
          isOpen={showScheduleInterviewModal}
          onClose={() => setShowScheduleInterviewModal(false)}
          modalAction={modalAction}
          selectedPayrollId={selectedPayrollId}
          refresh={refresh}
          setRefresh={setRefresh}
          cadre_position={cadre_position}
        />
      )}
    </PageStyle>
  );
}

export default ApplicantSelected;

function AcqTable({
  dob,
  email,
  firstName,
  gender,
  isDone,
  jobPostingId,
  lastName,
  maritalStatus,
  otherName,
  phone,
  interviewStatus,
  website,
  location,
  handleOpenModal,
  index,
  uuId,
  data,
  offerStatus,
  type,
}) {
  const navigate = useNavigate();

  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");

  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      // DEFINED_PERMISSIONS.HRManager,
    ];

    // Check if userPerm exists and matches any permission in hrPerm
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm); // Set matchedPermissionHr to the matched permission
    } else {
      setMatchedPermissionHr(""); // Reset to empty string if not matched
    }
  }, []);

  return (
    <>
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{FormatDateTime(dob, "ll")} </td>
        <td>{email}</td>
        <td>{firstName}</td>
        <td>{lastName}</td>
        <td>{otherName}</td>
        <td>{location}</td>
        <td>{phone}</td>
        <td>
          {interviewStatus === 1
            ? "Pending"
            : interviewStatus === 0
            ? "Approved"
            : interviewStatus === 7
            ? "Declined"
            : interviewStatus === 11
            ? "Cancelled"
            : interviewStatus === 2
            ? "Closed"
            : interviewStatus === 5
            ? "Selected"
            : interviewStatus === 4
            ? "Accepted"
            : interviewStatus === 30
            ? "ApprovedByEDO"
            : interviewStatus === 60
            ? "ApprovedByEDFI"
            : interviewStatus === 10
            ? "ApprovedByMD"
            : ""}
        </td>
        <td>
          {offerStatus === 1
            ? "Pending"
            : offerStatus === 0
            ? "Approved"
            : offerStatus === 7
            ? "Declined"
            : offerStatus === 11
            ? "Cancelled"
            : offerStatus === 2
            ? "Closed"
            : offerStatus === 5
            ? "Selected"
            : offerStatus === 4
            ? "Accepted"
            : offerStatus === 30
            ? "ApprovedByEDO"
            : offerStatus === 60
            ? "ApprovedByEDFI"
            : offerStatus === 10
            ? "ApprovedByMD"
            : ""}
        </td>
        <td>
          <TableActions
            hasChildren={true}
            url={`/dashboard/hr/recruitment-service/${data?.id}/view?status=approval&type=${type}`}
          >
            {[
              {
                name: "Attach to Cadre",
                action: () => handleOpenModal("Interview", data),
              },
              {
                name: "Upload Medicals",
                action: () =>
                  navigate(
                    `/dashboard/hr/recruitment-service/upload-medical-form/${data?.id}`
                  ),
              },
            ]}
          </TableActions>
        </td>
      </tr>
    </>
  );
}

// const AttachToCarde = ({
//   isOpen,
//   onClose,
//   modalAction,
//   selectedPayrollId,
//   refresh,
//   setRefresh,
// }) => {
//   const formMethods = useForm({ mode: "all" });
//   const dispatch = useDispatch();
//   const {
//     handleSubmit,
//     reset,
//     formState: { isValid },
//   } = formMethods;

//   if (!isOpen) return null;

//   const submit = async (data) => {
//     console.log("Data:", { data, modalAction, selectedPayrollId });
//     // onClose();

//     const payloadForInterview = {
//       applicantId: selectedPayrollId?.id,
//       scheduleDate: data.date,
//       interviewType: Number(data.interviewType),
//     };

//     const payloadForReschedule = {
//       interviewScheduleId: Number(selectedPayrollId?.interviewSchedules[0]?.id),
//       rescheduledDate: data.date,
//       interviewType: Number(data.interviewType),
//     };

//     try {
//       const actionDispatchFunction =
//         modalAction === "Interview"
//           ? await dispatch(ScheduleTnterviewWithCandidate(payloadForInterview))
//           : await dispatch(
//               RescheduleTnterviewWithCandidate(payloadForReschedule)
//             );
//       console.log("Action Dispatch Function:", actionDispatchFunction);
//       if (actionDispatchFunction?.payload?.successful === true) {
//         // Do something upon successful action
//         setRefresh(!refresh);
//         onClose();
//         toast.success(actionDispatchFunction?.payload?.statusMessage);
//       } else if (actionDispatchFunction?.payload?.successful === false) {
//         toast.error(actionDispatchFunction?.payload?.statusMessage);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <div
//       className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center"
//       onClick={onClose}
//     >
//       <div
//         className="relative mx-auto p-5 border w-96 shadow-lg rounded-md bg-white"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <h2 className="text-lg font-semibold text-gray-900 mb-4">
//           Attach to Cadre and Level
//         </h2>
//         <FormProvider {...formMethods}>
//           <FormTemplate handleSubmit={handleSubmit(submit)}>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   margin: "20px 0px",
//                 }}
//               >
//                 <label htmlFor="CadreGradeId">
//                   Cadre{" "}
//                   <sup
//                     style={{
//                       color: "red",
//                     }}
//                   >
//                     *
//                   </sup>
//                 </label>
//                 <FormControl fullWidth>
//                   <Select
//                     id="CadreGradeId"
//                     name="CadreGradeId"
//                     value={values.CadreGradeId || ""}
//                     onChange={(e) => {
//                       setFieldValue("CadreGradeId", e.target.value);
//                       const isFound = cadre_position?.result?.find(
//                         (x) => +e.target.value === x?.id
//                       );

//                       setSelectedCadreId(isFound?.cadreLevels);
//                     }}
//                     error={touched.CadreGradeId && Boolean(errors.CadreGradeId)}
//                     // disabled
//                   >
//                     {cadre_position?.result?.map((x) => (
//                       <MenuItem key={x.id} value={x?.id}>
//                         {x.title}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>
//                     {touched.CadreGradeId && errors.CadreGradeId}
//                   </FormHelperText>
//                 </FormControl>
//               </div>
//             </div>

//             {/* cadreLevelId */}
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   margin: "20px 0px",
//                 }}
//               >
//                 <label htmlFor="CadreLevelId">
//                   Level{" "}
//                   <sup
//                     style={{
//                       color: "red",
//                     }}
//                   >
//                     *
//                   </sup>
//                 </label>
//                 <FormControl fullWidth>
//                   <Select
//                     id="CadreLevelId"
//                     name="CadreLevelId"
//                     value={values.CadreLevelId || ""}
//                     onChange={(e) =>
//                       setFieldValue("CadreLevelId", e.target.value)
//                     }
//                     error={touched.CadreLevelId && Boolean(errors.CadreLevelId)}
//                     // disabled
//                   >
//                     {selectedCadreId?.map((x) => (
//                       <MenuItem key={x.id} value={x?.id}>
//                         {x.levelName}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                   <FormHelperText>
//                     {touched.CadreLevelId && errors.CadreLevelId}
//                   </FormHelperText>
//                 </FormControl>
//               </div>
//             </div>

//             <div className={DashboardStyle.button_cage}>
//               <button
//                 type="button"
//                 onClick={() => onClose()}
//                 className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={!isValid}
//                 className="px-6 py-2 bg-green-600 text-white rounded-md"
//               >
//                 Submit
//               </button>
//             </div>
//           </FormTemplate>
//         </FormProvider>
//       </div>
//     </div>
//   );
// };
